<template>
  <div>
    <div class="mb-4" v-show="show">
      <h6 class="font-weight-bold">Quando quer receber o pedido?</h6>
      <div class="row no-gutters">
        <div class="col-6 pr-1" v-if="empresa.aberto === '1'">
          <a href="javascript:" class="text-dark text-decoration-none" @click="changeHorario(null)">
            <div class="card card-horario" :class="{'active': !dados.id_entrega}" aria-hidden="true">
              <div class="card-body d-flex align-items-center">
                <div>
                  <b>Pedir agora</b>
                  <div class="small">Sem agendamento</div>
                </div>
                <div class="text-right" style="margin-left: auto" v-if="!dados.id_entrega">
                  <i class="fa fa-check text-primary"></i>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-6" :class="{'pl-1': empresa.aberto === '1'}">
          <a href="javascript:" class="text-dark text-decoration-none" @click="selAgendar()">
            <div class="card card-horario" :class="{'active': dados.id_entrega}" aria-hidden="true">
              <div class="card-body d-flex align-items-center">
                <div>
                  <b>{{agendamento ? (agendamento.data_formatada || 'Hoje') : 'Agendar'}}</b>
                  <div class="small" v-if="agendamento">{{agendamento.horario_inicio}} - {{agendamento.horario_fim}}</div>
                  <div class="small" v-else>Selecionar {{agendamento_maximo ? 'data' : 'horário'}}</div>
                </div>
                <div class="text-right" style="margin-left: auto">
                  <i class="fa fa-check text-primary" v-if="dados.id_entrega"></i>
                  <i class="fa fa-plus-circle text-primary" v-else></i>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div id="modalAgendamento" class="modal-agendamento" v-show="opened">
      <div class="modal-agendamento-content">
        <div class="py-4 py-md-3 bg-white shadow-sm mb-3">
          <div class="container text-center position-relative">
            <a href="javascript:" @click="closeModal" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px; border-radius: 50%" aria-label="Voltar">
              <i class="fa fa-chevron-left text-dark"></i>
            </a>
            <h1 class="h6 font-weight-bold m-auto">Agendar pedido</h1>
          </div>
        </div>
        <div class="container mb-4">
          <div v-if="agendamento_maximo && dias.length">
            <div class="mb-3">
              <label class="font-weight-bold m-0 small">Escolha um dia</label>
              <select class="form-control" v-model="dia" @change="changeDia()">
                <option :value="null">Hoje</option>
                <option :value="d" v-for="d in dias">{{ d.dataFormatada }}</option>
              </select>
            </div>
          </div>
          <h6 class="mt-1">Selecione um horário</h6>
          <div v-if="horarios.length">
            <div class="row no-gutters">
              <div class="col-6 px-1" v-for="(h, index) in horarios" :key="index">
                <a href="javascript:" class="text-dark text-decoration-none" @click="changeHorario(h)">
                  <div class="card card-horario mb-3" :class="{'active': h.id_entrega === dados.id_entrega}" aria-hidden="true">
                    <div class="card-body d-flex align-items-center">
                      <div>
                        <div class="small text-primary">{{ dia ? dia.dataFormatada : 'Hoje' }}</div>
                        <b>{{h.horario_inicio}} - {{h.horario_fim}}</b>
                      </div>
                      <div class="text-right" style="margin-left: auto" v-if="dados.id_entrega === h.id_entrega">
                        <i class="fa fa-check text-primary"></i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="alert alert-warning small mb-0" v-else>
            Data indisponível para agendamento.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ModalAgendamento",
    props: ['dados', 'agendamento', 'show'],
    data () {
      return {
        opened: false,
        finalizar: false,
        agendar: false,
        horarios: [],

        dias: [],
        agendamento_maximo: 0,
        horario: '',
        dia: null
      }
    },

    methods: {
      openModal() {
        document.body.classList.add("modal-open");
        this.opened = true;
        this.agendamento_maximo = parseInt(this.empresa.json_config.agendamento_maximo || '0');
        this.agendar = !!this.dados.id_entrega;
        this.dia = null;
        this.getDias();

        if (this.dados.dia_agendamento) {
          this.dia = this.dias.find(d => this.dados.dia_agendamento === d.date) || null;
        }

        this.changeDia();
      },

      closeModal() {
        this.finalizar = false;
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      changeHorario(h) {
        this.agendar = false;

        if (this.dia && h) {
          h.dia_agendamento = this.dia.date;
          h.data_formatada = this.dia.dataFormatada;
        }

        this.$emit('changeHorario', h, this.finalizar);

        if (h) {
          this.closeModal();
        }
      },

      getDias() {
        const agora = new Date();
        const dias = [];
        const diasSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

        for (let i = 0; i < this.agendamento_maximo; i++) {
          const proximoDia = new Date(agora);
          proximoDia.setDate(agora.getDate() + (i + 1));
          const dia = String(proximoDia.getDate()).padStart(2, '0');
          const mes = String(proximoDia.getMonth() + 1).padStart(2, '0');
          const ano = proximoDia.getFullYear();
          const semana = proximoDia.getDay();
          const dataFormatada = `${diasSemana[semana]} - ${dia}/${mes}`;
          dias.push({ date: `${ano}-${mes}-${dia}`, dataFormatada, semana: (semana + 1) });
        }

        this.dias = dias;
      },

      changeDia() {
        this.horarios = [];

        if (!this.dia) {
          this.horarios = this.empresa.entregas

        } else {
          this.horarios = this.empresa.agendamentos.filter(item => item.dia == this.dia.semana);
        }
      },

      selAgendar() {
        this.agendar = true;
        this.dia = null;
        this.changeDia();
        this.openModal();
      }
    },

    created() {
      this.$parent.$on('openModalHorario', (finalizar) => {
        this.finalizar = !!finalizar;
        this.openModal();
      });
    },

    computed: {
      empresa() {
        return this.$store.state.empresa;
      }
    }
  }
</script>

<style scoped>
  .card-horario {
    height: 90px;
  }

  .modal-agendamento {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-agendamento-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 500px;
    height: 75vh;
    position: relative;
    border-radius: 12px;
  }

  @media (max-width: 600px) {
    .modal-agendamento-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
    }
  }

  .card-horario.active {
    justify-content: normal!important;
    color: var(--lecard-primary);
    border: 2px solid var(--lecard-primary);
  }
</style>
